import axios from '@/utils/request'
var Qs = require('qs')

export default {
  // 2020-11-24
  search(params) {
    return axios.get('/return-backs?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2020-12-18
  create(params) {
    return axios.post('/return-backs', params);
  },

  // 2021-02-16
  updateReturnTracking(id, params) {
    return axios.put('/return-backs/' + id + '/update-return-tracking', params);
  },
  // 2021-02-16
  delete(id) {
    return axios.delete('/return-backs/' + id);
  },
  // 2020-11-28
  unFinishCount() {
    return axios.get('/return-backs/un-finish-count');
  },
  // 2021-01-20
  receiveFinish(id) {
    return axios.put('/return-backs/' + id + '/receive-finish');
  },

}

